import request, { MethodEnum, serverTriggerUrl } from '@/utils/fetch';

export enum COMMON_APIS {
  ENUMS = '/common/settings',
  REPORT_THREAD = '/common/reports',
  EMOJI_LIST = '/common/smiley',
  COLLECT = '/home/favorites',
}

export enum ENUM_KEYS {
  DELETE_THREAD_REASONS = 'modreasons',
}

export interface IAvatar {
  large: string;
  medium: string;
  small: string;
}

export interface IEmoji {
  /** 表情包编码 */
  code: string;
  /** 表情包资源位置 */
  url: string;
  /** 表情包类型，目前有三种，其中 “表情” 分类 size 要比其他小一圈，需要分开处理 */
  type?: string;
  /** 是否仅用于显示 */
  shownOnReply?: boolean;
}

export interface IEmojiList {
  directory: string; // 目录
  name: string;
  type: string;
  smiles: IEmoji[];
  shown_on_reply: boolean;
}

export interface IGetEmojiListRes {
  items: IEmojiList[];
}

export interface IGetEnumsRes {
  item: string[];
}

/** API */
// 枚举列表
export const getEnums = (isServerTrigger = false, params: any = {}, headers: any = {}, device = 'desktop') => {
  const url = `${isServerTrigger ? serverTriggerUrl : ''}${COMMON_APIS.ENUMS}/${params.key}`;
  const key = 'GetEnums';
  return request({ url, key, headers, isServerTrigger, params: { device } }).then((data: IGetEnumsRes) => {
    return data?.item;
  }).catch((e) => ([]));
};

// 表情包列表
/**
 * 获取表情包列表
 * @param isServerTrigger 是否服务端发起请求
 * @return
 */
export const getEmojiList = (isServerTrigger = false, headers: any = {}) => {
  const url = `${isServerTrigger ? serverTriggerUrl : ''}${COMMON_APIS.EMOJI_LIST}`;
  const key = 'GetEmojiList';
  return request({ url, headers, key, isServerTrigger }).then((data: IGetEmojiListRes) => {
    return data;
  }).catch((e) => {});
}

// 举报帖子或评论
export const reportContent = (params: any = {}) => {
  return request({
    url: COMMON_APIS.REPORT_THREAD,
    method: MethodEnum.POST,
    params,
  });
};

// 收藏
export const collectThread = (params: any = {}) => {
  return request({
    url: COMMON_APIS.COLLECT,
    method: MethodEnum.POST,
    params,
  }).then((data) => data);
};

// 取消收藏
export const uncollectThread = (params: any = {}) => {
  return request({
    url: `${COMMON_APIS.COLLECT}/${params.idtype}/${params.id}`,
    method: MethodEnum.DELETE,
  }).then((data) => data);
};
